// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2c8NI","list":"styles_list__hfruu"};